import type { EventName } from "@lit/react";
import { ConfirmDialog as ConfirmDialogElement, type ConfirmDialogEventMap as _ConfirmDialogEventMap, } from "@vaadin/confirm-dialog/vaadin-confirm-dialog.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ConfirmDialogElement, };
export type ConfirmDialogEventMap = Readonly<{
    onCancel: EventName<_ConfirmDialogEventMap["cancel"]>;
    onClosed: EventName<_ConfirmDialogEventMap["closed"]>;
    onConfirm: EventName<_ConfirmDialogEventMap["confirm"]>;
    onOpenedChanged: EventName<_ConfirmDialogEventMap["opened-changed"]>;
    onReject: EventName<_ConfirmDialogEventMap["reject"]>;
}>;
const events = { onCancel: "cancel", onClosed: "closed", onConfirm: "confirm", onOpenedChanged: "opened-changed", onReject: "reject" } as ConfirmDialogEventMap;
export type ConfirmDialogProps = WebComponentProps<ConfirmDialogElement, ConfirmDialogEventMap>;
export const ConfirmDialog = createComponent({
    elementClass: ConfirmDialogElement, events, react: React, tagName: "vaadin-confirm-dialog"
});
